import ApiService from '../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            cemeteries: [],
            activeTab: 'active'
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        }
    },
    mutations: {
        setCemeteries(state, value) {
            state.cemeteries = value;
        },
        addCemetery(state, value) {
            state.cemeteries.unshift(value);
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/cemetery', payload)
                    .then((response) => {
                        commit('setCemeteries', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        allCemeteries({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/cemeteries/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getCemetery({state, commit, getters} ,id){
            return new Promise((resolve, reject) => {
                ApiService.get('/cemetery/'+ id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        storeCemetery({state, commit, getters}, form){
            return new Promise((resolve, reject) => {
                ApiService.post('/cemetery', form)
                    .then((response) => {
                        if (state.activeTab === 'not-visited' || window.laravel.isMaster) {
                            commit('addCemetery',response.data);
                        }
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
    }
};


